import React, { useEffect, useState, memo } from 'react';
import { loadGoogleMapsScript } from '../services/GoogleMap';
import logo from "../assets/images/mapLogo.png";

const GoogleMapWithMarkers = memo(({ markers = [], center, selectedBranch }) => {
  const [map, setMap] = useState(null);
  const [googleMaps, setGoogleMaps] = useState(null);

  useEffect(() => {
    let mapInstance;
    const initializeMap = async () => {
      const map_key = localStorage.getItem('map_key') || process.env.REACT_APP_MAP_KEY;

      if (!map_key) {
        console.error("Google Maps API key is missing");
        return;
      }

      try {
        // Load Google Maps script
        await loadGoogleMapsScript(map_key);
        
        // Wait for google.maps to be available
        if (!window.google || !window.google.maps) {
          const checkInterval = setInterval(() => {
            if (window.google && window.google.maps) {
              clearInterval(checkInterval);
              createMap();
            }
          }, 100);
          return;
        } else {
          createMap();
        }

        function createMap() {
          const google = window.google;
          setGoogleMaps(google);

          // Use center prop if provided, otherwise default to first marker location or fallback
          const defaultLocation = center || (markers.length > 0 
            ? { lat: markers[0].lat, lng: markers[0].lng } 
            : { lat: 0, lng: 0 });

          mapInstance = new google.maps.Map(
            document.getElementById('map'),
            {
              center: defaultLocation,
              zoom: 12,
            }
          );

          setMap(mapInstance);

          // Add markers
          markers.forEach(markerData => {
            const isSelected = selectedBranch && selectedBranch._id === markerData._id;
            
            const marker = new google.maps.Marker({
              position: { lat: markerData.lat, lng: markerData.lng },
              map: mapInstance,
              title: markerData.title || markerData.name || '',
              icon: {
                url: logo,
                scaledSize: new google.maps.Size(isSelected ? 50 : 40, isSelected ? 50 : 40)
              },
              zIndex: isSelected ? 1000 : 1
            });

            marker.addListener('click', () => {
              if (markerData.onClick) {
                markerData.onClick(markerData);
              }
            });
          });
        }

      } catch (error) {
        console.error("Error loading Google Maps:", error);
      }
    };

    initializeMap();

    return () => {
      // Cleanup
      if (mapInstance) {
        // Remove all map listeners if needed
        window.google.maps.event.clearInstanceListeners(mapInstance);
      }
    };
  }, [markers, center, selectedBranch]);

  // Effect to center map when center prop changes
  useEffect(() => {
    if (map && center) {
      map.panTo(center);
      map.setZoom(14); // Zoom in a bit when centering on a specific location
    }
  }, [center, map]);

  return (
    <div 
      id="map" 
      style={{ 
        width: '100%', 
        height: '400px',
      }}
    />
  );
});

export default GoogleMapWithMarkers;